import { ThemeMode } from 'config';

// ==============================|| PRESET THEME - CityOptima1 ||============================== //

const CityOptima1 = (colors:any, mode:any) => {
  const { grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  let primaryColors = [
    '#E3EDF8', // lighter
    '#C7D9F1', // 100
    '#A9C5E9', // 200
    '#8BB1E2', // light
    '#6D9DDB', // 400
    '#267bc0ff', // main (SteelBlue)
    '#3B6A9D', // dark
    '#325A85', // 700
    '#294B6C', // darker
    '#203D54' // 900
  ];
  let errorColors = [
    '#FDECEA', // lighter
    '#F9BFBF', // light
    '#F28B8B', // main
    '#D96A6A', // dark
    '#B35B5B' // darker
  ];
  let warningColors = [
    '#FFF8E1', // lighter
    '#FFECB3', // light
    '#FFC107', // main
    '#FFB300', // dark
    '#FFA000' // darker
  ];
  let infoColors = [
    '#E1F5FE', // lighter
    '#81D4FA', // light
    '#4FC3F7', // main
    '#29B6F6', // dark
    '#0288D1' // darker
  ];
  let successColors = [
    '#E8F5E9', // lighter
    '#C8E6C9', // light
    '#81C784', // main
    '#66BB6A', // dark
    '#388E3C' // darker
  ];

  if (mode === ThemeMode.DARK) {
    // Dark mode: muted steel blue tones
    primaryColors = [
      '#18222B', // lighter
      '#24303B', // 100
      '#30404B', // 200
      '#3B5060', // light
      '#44506F', // 400
      '#345160', // main
      '#2E4656', // dark
      '#283D4C', // 700
      '#223443', // darker
      '#1C2B3A' // 900
    ];
    errorColors = ['#341d1b', '#b03725', '#dd3f27', '#e9664d', '#fbd6c9'];
    warningColors = ['#342a1a', '#83631a', '#dda116', '#e9ba3a', '#fbefb5'];
    infoColors = ['#202734', '#416fb0', '#4c88dd', '#74a8e9', '#ecf4fb'];
    successColors = ['#1f2e1c', '#449626', '#4fba28', '#74cf4d', '#e3fbd2'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
};

export default CityOptima1;
